<script setup lang="ts">
import { computed } from 'vue';
const emit = defineEmits(['click', 'update:modelValue']);

const props = defineProps({
  modelValue: [Boolean],
});

const checkValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

const checkClick = () => {
  checkValue.value = !checkValue.value;
  emit('click', !checkValue.value);
};
</script>

<template>
  <div
    class="fr-ac-jc select-box"
    :class="{ 'select-box-active': checkValue }"
    @click="checkClick"
  >
    <IconFont v-if="checkValue" name="icon_dagou" :size="12" color="#FFFFFF" />
  </div>
</template>

<style lang="scss" scoped>
.select-box {
  width: 18px;
  height: 18px;
  background: rgba(55, 133, 255, 0.3);
  border-radius: var(--border-radius);
  border: 1px solid #ffffff;
  flex-shrink: 0;
  cursor: pointer;
}

.select-box-active {
  background: #3785ff;
  border: 1px solid #3785ff;
}
</style>
